import { GetterTree } from 'vuex'
import { CallIvrMenusState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<CallIvrMenusState, RootState> = {
    ivrMenus:state => state.ivrMenus,
    ivrMenuItem:state => state.ivrMenuItem,
};
